import { render, staticRenderFns } from "./DeleteMany.vue?vue&type=template&id=1ed7a0bd&lang=pug"
import script from "./DeleteMany.vue?vue&type=script&lang=js"
export * from "./DeleteMany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports